import {
  ActiveOrdersNanodropContext,
  ActiveOrdersNanodropContextType,
} from '@/contexts/activeOrdersNanodrop/useActiveOrdersNanodropContext'
import { useActiveOrdersNanodrop } from '@/proxy/nanodrop/hooks/useActiveOrdersNanodrop'
import { CHECK_ORDERS_POLLING_TIME } from '@/seller.application.polling.time.config'
import { PropsWithChildren, useMemo } from 'react'

const ActiveOrdersNanodropProvider = ({ children }: PropsWithChildren) => {
  const {
    isFetching: isQueryFetching,
    isFetched: isQueryFetched,
    data: { activeOrdersNanodrop = [] } = {},
    refetch,
  } = useActiveOrdersNanodrop({
    gcTime: 0,
    refetchInterval: CHECK_ORDERS_POLLING_TIME,
    refetchIntervalInBackground: true,
  })

  const context: ActiveOrdersNanodropContextType = useMemo(
    () => ({
      activeOrdersNanodrop,
      isQueryFetching,
      isFetched: isQueryFetched,
      refetch,
    }),
    [activeOrdersNanodrop, isQueryFetching, isQueryFetched, refetch]
  )

  return (
    <ActiveOrdersNanodropContext.Provider value={context}>
      {children}
    </ActiveOrdersNanodropContext.Provider>
  )
}

export default ActiveOrdersNanodropProvider
